import type { MouseEventHandler } from 'react'

import { Space } from '@procurify/ui'

import { useLocalStorage } from '@webapp/hooks'
import {
  BudgetCategoryCardSubtotal,
  type BudgetCategoryCardSubtotalProps,
} from '../BudgetCategoryCardSubtotal'
import { BudgetSubtotalListStyled } from './styles/BudgetSubtotalsCollapsibleStyled'

interface BudgetCategoryCardSubtotalListProps extends BudgetCategoryCardSubtotalProps {
  subtotalList: BudgetCategoryCardSubtotalProps[]
}

export const BudgetCategoryCardSubtotalList = (
  props: BudgetCategoryCardSubtotalListProps
) => {
  const localStorageKey = `_show_budget_details[${props.label}]`
  const [isOpen, setIsOpen] = useLocalStorage(localStorageKey, true)

  const handleClick: MouseEventHandler<HTMLDetailsElement> = (event) => {
    event.preventDefault()
    setIsOpen(!event.currentTarget.open)
  }

  return (
    <Space>
      <Space.Item>
        <BudgetSubtotalListStyled>
          <details open={isOpen} onClick={handleClick}>
            <summary>
              <BudgetCategoryCardSubtotal
                {...props}
                labelIcon={isOpen ? 'chevron-thick-up' : 'chevron-thick-down'}
              />
            </summary>

            {props.subtotalList.map((subtotal, index) => (
              <BudgetCategoryCardSubtotal
                key={`${index}-${subtotal.label}`}
                label={subtotal.label}
                amount={subtotal.amount}
                percentage={subtotal.percentage}
                indicatorColor={'transparent'}
                shouldRenderPercentageFirst={props.shouldRenderPercentageFirst}
                shouldBoldAmount={props.shouldBoldAmount}
              />
            ))}
          </details>
        </BudgetSubtotalListStyled>
      </Space.Item>
    </Space>
  )
}
